import pluralize from 'pluralize';

import {joinStrings} from '#util/stringUtils';

// Returns a formatted string when passing in a formattedAge from the API.
// e.g. (1, 1) => "1 year and 1 month"
// e.g. (0, 2) => "2 months"
// e.g. (4, 0) => "4 years"
export const getFormattedAgeAsString = (years: number, months: number) => {
  const yearsString = years > 0 ? pluralize('year', years, true) : undefined;
  const monthsString = months > 0 ? pluralize('month', months, true) : undefined;
  return joinStrings([
    ...(yearsString ? [yearsString] : []),
    ...(monthsString ? [monthsString] : []),
  ]);
};
